module.exports = __webpack_public_path__ + "static/media/img-age-height.feba9cd7.svg";